export type MarkerShape = 'circle' | 'square' | 'wye' | 'star' | 'cross' | 'triangle' | 'diamond'

// SVG path data for each shape, centered at origin, sized to match current ~9px circle
export const MARKER_SHAPE_PATHS: Record<MarkerShape, string> = {
  circle: 'M4.514,0A4.514,4.514,0,1,1,-4.514,0A4.514,4.514,0,1,1,4.514,0',
  square: 'M-4,-4L4,-4L4,4L-4,4Z',
  wye: 'M0.6,0.6L0.6,4.5L-0.6,4.5L-0.6,0.6L-4,2.6L-3.4,1.5L-0.6,-0.1L-3.4,-1.5L-4,-2.6L-0.6,-0.6L-0.6,-4.5L0.6,-4.5L0.6,-0.6L4,-2.6L3.4,-1.5L0.6,-0.1L3.4,1.5L4,2.6L0.6,0.6Z',
  star: 'M0,-5L1.1,-1.5L4.8,-1.5L1.8,0.9L2.9,4.5L0,2.2L-2.9,4.5L-1.8,0.9L-4.8,-1.5L-1.1,-1.5Z',
  cross:
    'M-1.5,-5L1.5,-5L1.5,-1.5L5,-1.5L5,1.5L1.5,1.5L1.5,5L-1.5,5L-1.5,1.5L-5,1.5L-5,-1.5L-1.5,-1.5Z',
  triangle: 'M0,-5L4.33,3.5L-4.33,3.5Z',
  diamond: 'M0,-5.5L3.9,0L0,5.5L-3.9,0Z',
}

// Default shape sequence assigned to series by index
const DEFAULT_SHAPES: MarkerShape[] = [
  'circle',
  'square',
  'wye',
  'star',
  'cross',
  'triangle',
  'diamond',
]

export function getMarkerShape(seriesIndex: number): MarkerShape {
  return DEFAULT_SHAPES[seriesIndex % DEFAULT_SHAPES.length]
}
